import {
  IncidentSeverity,
  IncidentSeverityLevel,
  IncidentStatus,
  IncidentStatusLevel,
} from 'types/incidents.interface'

export const incidentSeverityOptions = [
  { label: 'L1 - Minor', value: 1 },
  { label: 'L2 - Moderate', value: 2 },
  { label: 'L3 - Serious', value: 3 },
  { label: 'L4 - Fatal / catastrophic', value: 4 },
]

export const incidentStatusOptions = [
  { label: 'Open', value: 1 },
  { label: 'Investigating', value: 2 },
  { label: 'Acknowledged', value: 3 },
  { label: 'Closed', value: 4 },
]

export const severityLevelToLabel = (level: IncidentSeverityLevel): IncidentSeverity =>
  `L${level}` as IncidentSeverity

export const severityLabelToLevel = (severity: IncidentSeverity): IncidentSeverityLevel =>
  Number(severity.slice(1)) as IncidentSeverityLevel

export const statusLevelToIncidentStatus = (status: IncidentStatusLevel): IncidentStatus => {
  const map: Record<IncidentStatusLevel, IncidentStatus> = {
    1: 'open',
    2: 'investigating',
    3: 'acknowledged',
    4: 'closed',
  }
  return map[status]
}

export const incidentStatusToLevel = (status: IncidentStatus): IncidentStatusLevel => {
  const map: Record<IncidentStatus, IncidentStatusLevel> = {
    open: 1,
    investigating: 2,
    acknowledged: 3,
    closed: 4,
  }
  return map[status]
}
